<template>
  <v-app-bar
    dense
    app
    flat
    :class="{
      darkaccent: is_preview,
      performance: is_anonymous && !is_preview
    }"
    dark
    v-if="!_.isEmpty(survey)"
  >
    <!-- <v-container fluid class="px-0"> -->
    <v-row dense>
      <v-col
        cols="12"
        class="subtitle-2 text-center darkaccent"
        v-if="is_preview"
      >
        <v-btn outlined small color="white" class="mr-2">
          Preview Mode
        </v-btn>
        Your answers will not be saved. Close this tab when you're done
        previewing
      </v-col>
      <v-col cols="12" class="subtitle-1 white--text text-center" v-else>
        <template v-if="is_anonymous">
          🕵️ Your answers will remain anonymous -
          <a
            href="https://help.corecounts.com/article/55-anonymity-in-corecounts"
            target="_blank"
            class="white--text text-decoration-underline"
          >
            Learn more
          </a>
        </template>
        <template v-else>
          👋 This survey is not anonymous & your name will appear next to your
          answers
        </template>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AppBar",
  components: {},
  data: () => ({}),
  computed: {
    ...mapGetters({
      is_anonymous: "survey/is_anonymous",
      is_preview: "survey/is_preview",
      survey: "survey/survey"
    })
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.preview-header {
  ::v-deep .v-toolbar__content {
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;
  }

  .container {
    padding-top: 0;
    padding-bottom: 0;
  }

  .theme--light.v-btn.v-btn--disabled {
    color: white !important;
  }
}
</style>
